/**
 * Allows to click some elements (with attribute drag-click-on-hover)
 * by hover them with dragged item.
 */
export class DragClick {
  public static waitForClickId: TimeoutHandler | undefined = undefined
  public static triggerClick(el: HTMLElement): void {
    el.classList.add('drag-click-active')
    setTimeout(() => el.classList.remove('drag-click-active'), 500)
    el.click()
    DragClick.removeDragClickables()
    DragClick.addDragClickables()
  }
  public static enter(event: MouseEvent): void {
    const el = event.target as HTMLElement
    el.classList.add('drag-click-hover')
    DragClick.waitForClickId = setTimeout(() => DragClick.triggerClick(el), 500)
  }
  public static leave(event: MouseEvent): void {
    const el = event.target as HTMLElement
    el.classList.remove('drag-click-hover')
    if (DragClick.waitForClickId) {
      clearTimeout(DragClick.waitForClickId)
    }
  }
  public static removeDragClickables(): void {
    const clickable = document.querySelectorAll('[drag-click-on-hover]')
    for (let i = 0; i < clickable.length; i++) {
      const el = clickable[i]
      el.removeEventListener('mouseenter', DragClick.enter)
      el.removeEventListener('mouseleave', DragClick.leave)
      el.classList.remove('drag-click')
    }
  }
  public static addDragClickables(): void {
    const clickable = document.querySelectorAll('[drag-click-on-hover]')
    for (let i = 0; i < clickable.length; i++) {
      const el = clickable[i]
      el.classList.add('drag-click')
      el.addEventListener('mouseenter', DragClick.enter)
      el.addEventListener('mouseleave', DragClick.leave)
    }
  }
}
